import { PasswordPolicy } from "@/api/openapi";
import { PasswordPolicyError } from "@/config/types";
import { validatePassword } from "@/config/utils";
import { Dispatch, SetStateAction } from "react";

type UseChangePasswordFormParams = {
  setOldPassword: (oldPassword: string) => void;
  setNewPassword: (newPassword: string) => void;
  setWrongPassword: (wrongPassword: boolean) => void;
  passwordPolicy: PasswordPolicy;
  setPasswordRequirements: Dispatch<
    SetStateAction<Record<PasswordPolicyError, boolean>>
  >;
};

export function useChangePasswordForm({
  setOldPassword,
  setWrongPassword,
  setNewPassword,
  setPasswordRequirements,
  passwordPolicy,
}: UseChangePasswordFormParams) {
  function onChangeOldPassword(password: string) {
    setOldPassword(password);
    setWrongPassword(false);
  }

  function onChangeNewPassword(password: string) {
    setNewPassword(password);
    setPasswordRequirements(validatePassword(password, passwordPolicy));
  }

  return { onChangeOldPassword, onChangeNewPassword };
}
